import badgeLabelComponent from './badgeLabel.component';

const badgeLabelModule = angular.module('app.common.badgeLabel', [])
	.component('badgeLabel', badgeLabelComponent)
	.name;

export default badgeLabelModule;
